import { advancedGet } from './client'
import { AdvancedTrackDefinition } from './types'
import { useAdvancedResource } from './useAdvancedResource'

const NO_TRACKS: AdvancedTrackDefinition[] = []

// Shares only an in-flight request, so a caseload of rows mounting together costs one fetch; a later mount refetches.
let inFlight: Promise<AdvancedTrackDefinition[]> | null = null

const loadCatalog = (): Promise<AdvancedTrackDefinition[]> => {
  inFlight =
    inFlight ??
    advancedGet<{ tracks: AdvancedTrackDefinition[] }>('/tracks')
      .then(({ tracks }) => tracks)
      .finally(() => {
        inFlight = null
      })

  return inFlight
}

export const useTrackCatalog = (): AdvancedTrackDefinition[] => {
  const resource = useAdvancedResource(loadCatalog, [])

  return resource.status === 'ready' ? resource.data : NO_TRACKS
}
